import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;

// Istanza dedicata all'area Consulente (cookie separato): su 401 torna al login consulente.
const consApi = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

consApi.interceptors.response.use(
  (res) => res,
  (err) => {
    const p = window.location.pathname;
    if (err?.response?.status === 401 && p.startsWith("/consulente") && !p.startsWith("/consulente/login")) {
      window.location.href = "/consulente/login";
    }
    return Promise.reject(err);
  }
);

export default consApi;
